export const USER_FETCH_STORE_ERROR = 'Ошибка при получении данных профиля в сторе:';
export const UNREAD_MESSAGES_FETCH_STORE_ERROR =
  'Ошибка при получении непрочитанных сообщений в сторе:';
export const PASSWORD_UPDATE_ERROR = 'Ошибка при обновлении пароля:';
export const AVATAR_DELETE_ERROR = 'Ошибка при удалении аватара:';
